import { render, staticRenderFns } from "./CardProblem.vue?vue&type=template&id=471b3cf5&scoped=true&"
import script from "./CardProblem.vue?vue&type=script&lang=js&"
export * from "./CardProblem.vue?vue&type=script&lang=js&"
import style0 from "./CardProblem.vue?vue&type=style&index=0&id=471b3cf5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471b3cf5",
  null
  
)

export default component.exports